<template>
  <div id="app">
    <!-- <div v-if="!isMobile()">
      <div class="desktop-container">
        <div class="image-container">
          <img class="logo-image" alt="logo" src="./assets/images/logo2.png" />
        </div>
        <h3>To use the Live competition please open from a mobile device</h3>
        <h3>لاستخدام المسابقة اللايف ، يرجى فتحها من جهاز محمول</h3>
      </div>
    </div> -->
    <div class="app-container">
      <router-view />
    </div>
    <div v-if="showToolTip">
      <div class="tooltip">
        <div
          v-if="engToolTip"
          class="tooltiptext"
          :style="showToolTip ? { visibility: 'visible' } : {}"
        >
          <span
            @click="hideToolTip"
            style="margin: 2px;font-size: 24;display: inline-block"
            ><Close></Close
          ></span>
          <span style="font-size: 15px;padding: 5px"
            >You can add this web link to your home page <br />
            so you access the competition faster. <br />
            tap
            <Share style="font-size: 20px;display: inline-block"></Share> then
            add to home screen
          </span>
        </div>
        <div
          v-else
          class="tooltiptext"
          :style="
            showToolTip ? { visibility: 'visible', direction: 'rtl' } : {}
          "
        >
          <span
            @click="hideToolTip"
            style="margin: 2px;font-size: 24;display: inline-block"
            ><Close></Close
          ></span>
          <span style="font-size: 15px;padding: 5px">
            لو عايز تخش اسرع علي المسابقه في اي وقت <br />
            ممكن تزود اللينك ده علي الشاشه الرئيسيه. <br />
            كل اللي محتاج تعمله انك تزودها هنا
            <Share style="font-size: 20px;display: inline-block"></Share>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Close from "vue-ionicons/dist/ios-close-circle-outline";
import Share from "vue-ionicons/dist/ios-share";
export default {
  data() {
    return {
      showToolTip: false,
    };
  },
  created() {
    // console.log("env", process.env);
    // single video
    if (this.$route.query.videoId) {
      const singleVideoData = this.$route.query.videoId;
      sessionStorage.setItem("vid", singleVideoData);
      this.$store.dispatch("saveSingleVideoData", singleVideoData);
    }
    // single comment
    if (this.$route.query.commentId) {
      const singleCommentData = this.$route.query.commentId;
      sessionStorage.setItem("com", singleCommentData);
      this.$store.dispatch("saveSingleCommentData", singleCommentData);
    }
    // single profile
    if (this.$route.query.competitionId && this.$route.query.profileId) {
      const profileId = this.$route.query.profileId;
      const competitionId = this.$route.query.competitionId;
      sessionStorage.setItem("pro", profileId);
      sessionStorage.setItem("compid", competitionId);
      const singleProfileData = {
        profile: profileId,
        competitionId,
      };
      this.$store.dispatch("saveSingleProfileData", singleProfileData);
    }

    this.$store.dispatch("saveUrl");
    if (window.navigator.language.includes("ar")) {
      localStorage.setItem("lang", "ar");
    } else {
      localStorage.setItem("lang", "en");
    }
    let userAgent = window.navigator.userAgent.toLowerCase();
    if (/iphone/.test(userAgent)) {
      const isInStandaloneMode = () =>
        "standalone" in window.navigator && window.navigator.standalone;
      const tools = localStorage.getItem("t");
      if (!isInStandaloneMode()) {
        if (tools !== "f") {
          this.showToolTip = true;
        }
      }
    }
  },
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    hideToolTip() {
      localStorage.setItem("t", "f");
      this.showToolTip = false;
    },
  },
  components: {
    Close,
    Share,
  },
  computed: {
    engToolTip() {
      if (window.navigator.language.includes("ar")) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style>
@font-face {
  font-family: AvenirNextHeavy;
  src: url("./assets/fonts/AEH.ttf");
}
@font-face {
  font-family: AvenirNextBold;
  src: url("./assets/fonts/AvenirNextLTPro-Bold.otf");
}
@font-face {
  font-family: AvenirNextRegular;
  src: url("./assets/fonts/AvenirNextLTPro-Regular.otf");
}
html {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overscroll-behavior: contain;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}
.desktop-container {
  margin: 20px 0;
  text-align: center;
  font-size: 1rem;
}

.image-container {
  width: 100%;
  max-width: 480px;
  margin: 10px auto;
}
.logo-image {
  width: 60%;
}
.app-container {
  width: 100%;
  height: 100%;
}
.tooltip .tooltiptext {
  width: 100%;
  background-color: #ccc;
  color: #191919;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1000;
  left: 0;
  bottom: 20px;
}

.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #ccc transparent transparent transparent;
}
</style>
